<template>
  <div>
    <v-card flat
            tile>
      <v-toolbar color="secondary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('details') }}</v-toolbar-title>
      </v-toolbar>
      <department-details ref="departmentDetails"
                          v-bind:department="department" />
    </v-card>
  </div>
</template>

<script>
  import DepartmentDetails from '@/components/DepartmentDetails'

  export default {
    components: {
      DepartmentDetails
    },
    name: 'DepartmentDetailsCard',
    methods: {
      validate() {
        return this.$refs.departmentDetails.validate()
      }
    },
    props: {
      department: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "details": "Details"
    },
    "en": {
      "details": "Details"
    }
  }
</i18n>